<template>
  <div
    class="relative bg-[#FFF] h-full w-full flex items-center justify-center py-8 px-4"
  >
    <div
      class="mx-4 md:mx-7 lg:mx-auto lg:max-w-[1064px] h-full flex items-center gap-x-4"
    >
      <div>
        <p
          class="poppins font-semibold text-[25px] lg:text-[31.25px] text-[#000] leading-[100%]"
        >
          Soft <br />
          Skills
        </p>
        <div class="flex flex-wrap max-w-[550px] mt-8">
          <p
            v-for="(data, index) in softSkill"
            :key="index"
            class="poppins font-normal text-[12px] lg:text-[16px] text-[#F44F1A] px-4 py-2 border-solid border-[1px] border-[#F44F1A] rounded-[30px] w-max mr-2 mb-4"
          >
            {{ data }}
          </p>
        </div>
        <p
          class="poppins font-semibold text-[25px] lg:text-[31.25px] text-[#000] leading-[100%] mt-8 lg:mt-4"
        >
          Hard <br />
          Skills
        </p>
        <div class="flex flex-wrap max-w-[550px] mt-8">
          <p
            v-for="(data, index) in hardSkill"
            :key="index"
            class="poppins font-normal text-[12px] lg:text-[16px] text-[#F44F1A] px-4 py-2 border-solid border-[1px] border-[#F44F1A] rounded-[30px] w-max mr-2 mb-4"
          >
            {{ data }}
          </p>
        </div>
      </div>
      <img
        class="h-[609px] w-[451px] hidden lg:block"
        src="@/assets/skill_figure.png"
        alt="skill figure"
      />
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const softSkill = ref([
  "Communication",
  "Team Work",
  "Responsibility",
  "Leadership",
  "Curiosity",
  "Problem Solving",
]);
const hardSkill = ref([
  "HTML",
  "CSS",
  "JavaScript",
  "Vue Js",
  "Nuxt Js",
  "React Js",
  "Next Js",
  "Tailwind CSS",
  "SCSS",
  "Figma",
  "Firestore",
  "Git",
  "Phaser",
  "Responsive Web Design",
  "Interactive Web Design",
]);
</script>

<style></style>
